import type React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorBoundary } from '@/components/errorBoundary';
import { ShiftRegisterContent } from './ShiftRegisterContent';

/**
 * Self-served shift register section: its own boundary for render failures,
 * with the data hook, loading skeleton and inline load errors inside
 * `ShiftRegisterContent`.
 */
export const ShiftRegister: React.FC = () => {
    const { t } = useTranslation('pages');

    return (
        <ErrorBoundary
            data-testid="shift-register-error-boundary"
            fallbackMessage={t('shifts.errorMessage')}
            id="shift-register-error-boundary"
            retryLabel={t('shifts.errorRetry')}
            title={t('shifts.errorTitle')}
        >
            <ShiftRegisterContent />
        </ErrorBoundary>
    );
};
